import { Injectable } from '@angular/core';
import { EventDelegatorService } from '@services/event-delegator.service';
import { MakersiteService } from '@services/makersite.service';
import { AnalyzeService } from './analyze.service';
import { Router } from '@angular/router';

@Injectable()
export class AnalyzeLayersService {
  constructor(
    private analyzeService: AnalyzeService,
    private eventDelegatorService: EventDelegatorService,
    private makersiteService: MakersiteService,
    private router: Router,
  ) {}

  switchApp(event) {
    const app = event.data;
    this.analyzeService.setAnalyzeData(undefined);
    const rid = this.analyzeService.getAnalyzeRid();
    const { module } = app;
    switch (module) {
      case 'reports':
        this.windowOpen('/report');
        break;
      case 'history':
        this.windowOpen('/reports/history');
        break;
      case 'master-data-management':
        this.windowOpen('/data-management');
        break;
      case 'insights':
        this.windowOpen(`insights/${rid}`);
        break;
      case 'explorer':
        this.windowOpen(`/explorer/${rid}`);
        break;
      case 'pef-analysis':
        this.windowOpen(`/pef-analysis/${rid}`);
        break;
      case 'epd-dashboard':
        this.windowOpen(`/epd-v2/${rid}`);
        break;
      case 'cbam-dashboard':
        this.windowOpen(`/cbam-dashboard/${rid}`);
        break;
      case 'ihm-eu-dashboard':
        this.windowOpen(`/ihm-eu-dashboard/${rid}`);
        break;
      case 'ecodesign-dashboard':
        this.windowOpen(`/ecodesign/${rid}`);
        break;
      case 'scip-notification':
        this.windowOpen(`/scip/${rid}`);
        break;
      default:
        this.checkAppAvailability(app);
        break;
    }
  }

  checkAppAvailability(app) {
    const rid = this.analyzeService.getAnalyzeRid();
    if (!rid) return;
    this.makersiteService.checkAppAvailability(rid, app.layer).subscribe(() => {
      const url = `mattermaps/${app.layer}/${rid}`;
      this.windowOpen(url);
    }, (error) => {
      this.analyzeService.unauthorizedDataset(error, rid, true);
    });
  }

  windowOpen(url) {
    this.analyzeService.setAnalyzeData(undefined);
    this.router.navigate([url]);
  }
}
